import moment from "moment";
import React, { useState, useEffect, useContext } from "react";
import { intlContext } from "translations/context";

interface Props {
  endDateTime?: string;
  style?: React.CSSProperties;
}

export default function Timer({ endDateTime, style }: Props): JSX.Element {
  const { translate } = useContext(intlContext);
  const [days, setDays] = useState<number>(0);
  const [hours, setHours] = useState<number>(0);

  useEffect(() => {
    if (endDateTime == null) return;
    const daysDiff = moment(endDateTime).diff(moment()) / 1000 / 60 / 60 / 24;
    if (daysDiff < 0) {
      setDays(-1);
      setHours(-1);
    } else {
      setDays(Math.floor(daysDiff));
      setHours(Math.floor(daysDiff * 24 - Math.floor(daysDiff) * 24));
    }
  }, [endDateTime]);

  if (endDateTime == null) return <React.Fragment />;

  if (days < 0 || hours < 0) return <React.Fragment>{translate("project_list_startpage_timer_is_completed")}</React.Fragment>;

  return (
    <div style={{ width: "100%", textAlign: "center", ...style }}>
      {translate("project_list_startpage_timer_ends_in")}&nbsp;
      {days === 1 ? `1 ${translate("project_list_startpage_timer_day")}` : `${days} ${translate("project_list_startpage_timer_days")}`}&nbsp;
      {translate("project_list_startpage_timer_and")}&nbsp;
      {hours === 1 ? `1 ${translate("project_list_startpage_timer_hour")}` : `${hours} ${translate("project_list_startpage_timer_hours")}`}
    </div>
  );
}
